webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(14),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(16),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PortalWindow__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PortalWindow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PortalWindow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PortalPage__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PortalPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PortalPage__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PortalWindow", function() { return __WEBPACK_IMPORTED_MODULE_0__components_PortalWindow___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PortalPage", function() { return __WEBPACK_IMPORTED_MODULE_1__components_PortalPage___default.a; });






/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PortalPage',
  data: function data() {
    return {
      isOpen: false
    };
  },
  computed: {
    isEmbedded: function isEmbedded() {
      if (window.portalHost) {
        return true;
      }
      return false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('portalactivate', function (event) {
      _this.isOpen = true;
    });
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PortalWindow',
  props: {
    src: String
  },
  computed: {
    supportsPortals: function supportsPortals() {
      return 'HTMLPortalElement' in window;
    }
  },
  methods: {
    activate: function activate() {
      if (this.supportsPortals) {
        this.$refs.portal.activate();
      }
    }
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.supportsPortals) ? _c('portal', {
    ref: "portal",
    attrs: {
      "src": _vm.src
    }
  }, [_vm._t("default")], 2) : _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isOpen) ? _vm._t("open") : (_vm.isEmbedded) ? _vm._t("embed") : _vm._t("default")], 2)
},staticRenderFns: []}

/***/ })
],[7]);


// WEBPACK FOOTER //
// docs/js/template.320681540a0df84430ff.js